import React, { useContext, useState } from 'react'
import CommissionAdminContext from '../../../context/CommissionAdminContext'
import commissionParser from '../commissionParser'
import Loading from '../../Loading'
import { CommissionAdminValues } from '../../../types'
import FetchBuilder from '../../../fetch/FetchBuilder'
import FileDisplayed from '../FileDisplayed'
import {unmarshall} from '@aws-sdk/util-dynamodb'
import { AttributeValue } from '@aws-sdk/client-dynamodb'


const FileFetcher = () => {
  const {
    handleAuthorization,
    commissionValues: { commissionResponse, handleCommissionResponse }
  } = useContext<CommissionAdminValues>(CommissionAdminContext)

  React.useEffect(() => {
    (async () => {
      const listingResponse = await new FetchBuilder().setPath('commission-admin').build()
      if (listingResponse?.status === 403) {
        handleAuthorization()
      }

      const metadataResponse = await new FetchBuilder().setPath('commission-admin').buildMetadataGet()
      if (metadataResponse?.status === 403) {
        handleAuthorization()
      }

      //Get metadata
      const metadataJson = await metadataResponse.json()
      const items = metadataJson.Items.map((item: Record<string, AttributeValue>) => unmarshall(item));

      const commissionsDOM = await listingResponse.text();
      const commissions = commissionParser(commissionsDOM, items)
      handleCommissionResponse(commissions!);
    })();
  }, [])


  return !commissionResponse ? <Loading animated={true}/> : <FileDisplayed commissionData={commissionResponse}/>
}
export default FileFetcher;